import {Injectable, Component, OnInit, ViewEncapsulation, Injector, Input, HostListener } from '@angular/core';
import { BaseComponent } from '../../base.component'
import {SwatchChangedEvent} from "../../events/swatch.changed.event";
import {SwatchModel} from "../../models/swatch.model";
import {PaletteModel} from "../../models/palette.model";
import {PalettesModel} from "../../models/palettes.model";
import { ColorPickerService } from '../../components/color-picker/color-picker.service';
declare var jQuery: any;

@Injectable({
	providedIn: 'root'
  })
@Component({
	selector: 'common-mini-workspace',
	templateUrl: './mini-workspace.html',
	styleUrls: ['./mini-workspace.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MiniWorkspace extends BaseComponent implements OnInit {
	swatchesList: any[] = []
	@Input() palette: PaletteModel;
	@Input() palettes: PalettesModel;
	@Input() swatch: SwatchModel;
	@Input() isComparison: Boolean;
	screenWidth = window.innerWidth - 60
	setWidth = window.innerHeight - 115
	viewCount = 16
	constructor(public injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		var widthUL = jQuery('ul.workspacecolors').outerWidth();
		var boxH = jQuery(widthUL / 16);
		jQuery('ul.workspacecolors').css('height',boxH[0]+'px');
		this.createScrollScript()
		this.screenWidth = window.innerWidth - 60
		this.setWidth = window.innerHeight - 115
		this.viewCount = (window.innerWidth > 1024)? 16: 8
	}
	@HostListener('window:resize', ['$event'])
	onResize(event){

		this.screenWidth = window.innerWidth - 60
		this.setWidth = window.innerHeight - 115
		this.viewCount = (window.innerWidth > 1024)? 16: 8
		var widthUL = jQuery('ul.workspacecolors').outerWidth();
		var boxH = jQuery(widthUL / 16);
		jQuery('ul.workspacecolors').css('height',boxH[0]+'px');
	}

	contrastingFontColor(swatch): string {
    return ColorPickerService.isDarkColor(swatch.rgb) ? 'rgb(255, 255, 255)' : 'rgb(0, 0, 0)';
  }


	missingTagBlack(swatch): any {
		if(swatch.empty || this.palette.shouldShowMissingTags == false){
			return false;
		} else {
			return swatch.missingRefTag;
		}
	}
	dropped(event: any, swatchIndex: number) : void {
		if (typeof event.dragData.dragIndex != 'undefined') {
		  // move swatch from dragIndex to swatchIndex
		  var element = this.palette.swatches[event.dragData.dragIndex];
		  this.palette.swatches.splice(event.dragData.dragIndex, 1);
		  this.palette.swatches.splice(swatchIndex, 0, element);
		} else {
		  let indexSwatch = this.palette.swatches[swatchIndex];
		  indexSwatch.copy(event.dragData.swatch);
		  if (indexSwatch.refnumber == '' || indexSwatch.refname == '') {
			indexSwatch.missingRefTag = true;
		  }
		  else{
			indexSwatch.missingRefTag = false;
		  }
		  this.palettes.selectedSwatch.selected = false;
		  this.palettes.selectedSwatch = indexSwatch;
	
		if (this.palettes.selectedPalette.savedReferenceName.length > 0) {
		  this.palettes.selectedPalette.enableMerge = true;
	  }
		}
		this.palettes.selectedPalette.palletSaved = false;
		this.palettes.writeDefaultFile();
	}

	selectSwatch(event):void {
		if(event.selected == true){
			event.selected = false;
		} else {
			this.palettes.selectedPalette.deselectAllSwatches();

			var o = new SwatchChangedEvent({
				"oldSwatchId": this.palettes.selectedSwatch.id,
				"oldPaletteId": this.palettes.selectedPalette.id,
				"newSwatch": event,
				"newPalette": this.palette
			});
			event.selected = true;
			this.palettes.selectedSwatch = event;
		// this.gm.colorUtility.generateColors(this.palettes.selectedSwatch.rgb, this.palettes.selectedSwatch);
			this.palettes.selectedPalette = this.palette;
			this.palettes.data.activePaletteId = this.palette.id;
			this.palettes.swatchChanged.emit(o);
		}
        
	}
	

	deleteSwatch(swatch){
		if(swatch.empty){
			alert("The swatch is already empty.");
			return;
		} else {
		  for ( var i = 0; i < this.palette.swatches.length; i ++ ) {
			if (this.palette.swatches[i].id === swatch.id) {
				let deletedSwatch = Object.assign({}, this.palette.swatches[i]);
				let index = this.palettes.selectedPalette.swatches.findIndex(x=>x.id==this.palette.swatches[i].id);
				let deletedArr = {index:index, data:deletedSwatch};
				this.gm.deletedStack.push(deletedArr);
			  this.palette.swatches[i].empty = true;
			  this.palette.swatches[i].zcc = ""
			  this.palette.swatches[i].contrastingFontColor = "white";
			  this.palettes.selectedSwatch = new SwatchModel({});
			  this.palettes.updatePalette(this.palette);
			  this.palettes.writeDefaultFile();
			}
		  }
		}
	}

	  deleteSelectedPalette(){
		if (this.palettes.selectedSwatch.empty == false) {
		  let deletedSwatch = Object.assign({}, this.palettes.selectedSwatch);
		  let index = this.palettes.selectedPalette.swatches.findIndex(x=>x.id==this.palettes.selectedSwatch.id);
		  let deletedArr = {index:index, data:deletedSwatch};
		  this.gm.deletedStack.push(deletedArr);
		  this.palettes.selectedSwatch.empty = true
		  this.palettes.selectedSwatch.refname = ""
		  this.palettes.selectedSwatch.refnumber = ""
		  this.palettes.selectedSwatch.contrastingFontColor = "white";
		  this.palettes.updatePalette(this.palettes.selectedSwatch);
		  this.palettes.writeDefaultFile();
		}
	  }

	  removeAllPallets() {
			this.gm.deletedAllStack = [];
			for (let i = 0; i < this.palettes.selectedPalette.swatches.length; i++) {
				let swatch = this.palettes.selectedPalette.swatches[i];
				if (swatch.empty == false) {
					let deletedSwatch = Object.assign({}, swatch);	
					let deletedArr = {index:i, data:deletedSwatch};
					this.gm.deletedAllStack.push(deletedArr);
				}
			}
			this.palettes.removePalette( this.palette );
			this.palettes.writeDefaultFile();
			this.gm.deletedStack = [];
		}
		undoDelete(){

			if (this.gm.deletedAllStack.length > 0) {
				//fill the stacks on clear all
				while (this.gm.deletedAllStack.length > 0) {
					let lastDeleted = this.gm.deletedAllStack.pop();
					this.palettes.selectedPalette.swatches[lastDeleted.index] = lastDeleted.data;
					this.palettes.updatePalette(this.palettes.selectedPalette.swatches[lastDeleted.index]);
					this.palettes.selectedPalette.swatches[lastDeleted.index];
					var o = new SwatchChangedEvent({
						"oldSwatchId": this.palettes.selectedSwatch.id,
						"oldPaletteId": this.palettes.selectedPalette.id,
						"newSwatch": lastDeleted.data,
						"newPalette": this.palette
				});
				
				this.palettes.selectedPalette = this.palette;
				this.palettes.data.activePaletteId = this.palette.id;
				}
				this.palettes.writeDefaultFile();
				this.palettes.selectedPalette.deselectAllSwatches();
				this.palettes.swatchChanged.emit(o);
				this.gm.deletedAllStack = [];
				return
			}
			let lastDeleted = this.gm.deletedStack.pop();
			if(lastDeleted){
				this.palettes.selectedPalette.swatches[lastDeleted.index] = lastDeleted.data;
				this.palettes.updatePalette(this.palettes.selectedSwatch);
				this.palettes.writeDefaultFile();
				this.palettes.selectedPalette.deselectAllSwatches();
				this.palettes.selectedPalette.swatches[lastDeleted.index].selected = true;
				var o = new SwatchChangedEvent({
					"oldSwatchId": this.palettes.selectedSwatch.id,
					"oldPaletteId": this.palettes.selectedPalette.id,
					"newSwatch": lastDeleted.data,
					"newPalette": this.palette
			});
			this.palettes.selectedSwatch = lastDeleted.data ;
			this.palettes.selectedPalette = this.palette;
			this.palettes.data.activePaletteId = this.palette.id;
	
			this.palettes.swatchChanged.emit(o);
		}
	}
	createScrollScript () {
		var s = document.createElement( 'script' );
		s.setAttribute( 'src', '../../../assets/scrollbar.js' );
		s.onload=() =>{
			jQuery('body').find("#workspacecolors").customScrollbar();
		};
		document.body.appendChild( s );
	}

		
		contrastingCheckIconColor(swatch): string {
		return ColorPickerService.isDarkColor(swatch.rgb) ? 'check' : 'black-check';
		}
		
		contrastingCrossIconColor(swatch): string {
		return ColorPickerService.isDarkColor(swatch.rgb) ? 'close' : 'black-close';
		}

}